import styled, { css } from 'styled-components';

const cssLarge = css`
  --btn-height: 80px;
  height: var(--btn-height);
  padding: 0px 32px;
  font-size: 36px;
`;

const cssMedium = css`
  --btn-height: 64px;
  height: var(--btn-height);
  padding: 0px 26px;
  font-size: 29px;
`;

const cssSmall = css`
  --btn-height: 54px;
  height: var(--btn-height);
  padding: 0px 20px;
  font-size: 24px;
`;

const cssBySize = {
  large: cssLarge,
  medium: cssMedium,
  small: cssSmall,
};

const StyledBtnGeneric = styled.button`
  cursor: pointer;
  font-family: "Quicksand Bold";
  border: 0;
  border-radius: 100px;
  color: ${props => props.textColor};
  background: ${props => props.bkgColor};

  &:not(:disabled):active {
    box-shadow: none;
  }

  ${props => cssBySize[props.size]}
`;

export default StyledBtnGeneric;
